import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import styles from './SectionWithMap.css';

type SectionWithMapProps = {
  children: Array<ReactNode> | ReactNode;
  isShort: boolean;
  map: JSX.Element;
};

export const SectionWithMap: FC<SectionWithMapProps> = props => {
  const { children, isShort, map } = props;

  return (
    <section className={styles['container']}>
      <div className={clsx(styles['inner'], isShort && styles['is-short'])}>{children}</div>
      {map}
    </section>
  );
};
